import { useAppSelector } from 'flow/hooks/useRedux';
import { ReferKey } from 'flow/types/EntityKeys';
import ActiveProfile from '../ActiveProfile';

interface Props {
    referKey: ReferKey;
}

const IvrActiveProfile = ({ referKey }: Props) => {
    const isEditable = useAppSelector((state) =>
        state.pbx.getIn(['refers', referKey, 'editable']),
    );
    const activeProfile = useAppSelector((state) =>
        state.pbx.getIn(['refers', referKey, 'activeProfile']),
    );

    return (
        <ActiveProfile
            entityKey={referKey}
            isEditable={isEditable}
            routeKey="pbx.refers.entityKey.profiles"
            activeProfile={activeProfile}
        />
    );
};

export default IvrActiveProfile;
